<template>
	<v-container id="overviews" fluid >

		<!-- >>> The Data Table -->
		<v-data-table
			v-model="selected"
			style="margin-bottom: 0px; margin-top: 0px;"
			:headers="headers"
			:items="get_Resources_Filtered"
			:disable-pagination="true"
			:hide-default-footer="true"
			sort-by="fullName"
			:single-expand="singleExpand"
			:expanded.sync="expanded"
			show-expand
			show-select
			:single-select="singleSelect"
			class="elevation-1 data-table-custom-colors"
			@dblclick:row="(event, resourceItem) => onDblClick_DataTableRow(resourceItem.item)">
			<!-- @contextmenu:row="(event, resourceItem) => onContextMenu_DataTableRow(event, resourceItem.item)"> -->

			<template v-slot:item.active="{ item }">
				<v-chip small outlined color="#4caf50" v-if="item.active === true" @click="onClick_ActiveChip(item)">
					Active
				</v-chip>
				<v-chip small outlined color="#ab3b7a" v-if="item.active === false" @click="onClick_ActiveChip(item)">
					Inactive
				</v-chip>
			</template>

			<template v-slot:item.experiencedFrom="{ item }">
				<p style="font-weight:300; margin: 0;">{{ item.experiencedFrom | dayjsUtcDe }}</p>
			</template>

			<template v-slot:item.contractFunction="{ item }">
				<p style="font-weight:500; margin: 0;display:inline;">{{ item.contractFunction }}</p>
			</template>

			<template v-slot:item.contractBaseStationCode="{ item }">
				<p style="font-weight:500; margin: 0;">{{ item.contractBaseStationCode }}</p>
			</template>

			<template v-slot:item.fullName="{ item }">
				<div style="display:flex;flex-direction:row;">
					<div style="display:flex;flex-direction:column;">
						<p style="font-weight:500; margin: 0;">{{ item.fullName }} - {{ item.contract3Code }}</p>
						<p style="font-weight:300; margin: 0; font-size: 14px;">
							<a :href="'tel:' + item.comPhone1">Tel.: {{ item.comPhone1 }}</a>
						</p>
					</div>
					<div>
						<p v-if="item.freelance === true" style="margin-left:10px;color:#EF6C00;display:inline;font-weight:600;"  color="" dark>
							F
						</p>
					</div>
				</div>
			</template>

			<template v-slot:item.idHrDepartment="{ item }">
				<p v-if="item.idHrDepartment === 12" style="margin: 0; display: inline;">Cockpit</p>
				<p v-if="item.idHrDepartment === 11" style="margin: 0; display: inline;">Cabin</p>
			</template>

			<!-- >>> Action:Column -->
			<template v-slot:item.actions="{ item }">
				<span style="margin-left: 15px;">
					<v-icon small class="mr-2" @click="onDblClick_DataTableRow(item)" :class="get_ClassForEditedRow(item)">
						mdi-pencil
					</v-icon>
					<!-- <v-icon small @click="onClick_DeleteResource(item)">
						mdi-delete
					</v-icon> -->
				</span>
			</template>
			<!-- <<< Action:Column -->

			<!-- >>> Expanded:Column -->
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length">
					<div style="margin-left: 0px; margin-top: 24px; margin-bottom: 24px;">
						<!-- <strong>Contact Information</strong><br /> -->
						<div style="display:flex;flex-direction:column;">
							<div style="display:flex;flex-direction:row;align-items:center;padding:0;">
								<v-icon style="margin-right:16px;">mdi-map-marker</v-icon>
								<div style="display:flex;flex-direction:column;">
									<p style="margin:0">{{ item.addressStreet }} {{ item.addressHousenumber }}</p>
									<p style="margin:0">{{ item.addressZip }} {{ item.addressCity }}</p>
								</div>
							</div>

							<div style="display:flex;flex-direction:row;align-items:center;padding:0;padding-top:8px;">
								<v-icon style="margin-right:16px;">mdi-at</v-icon>
								<div style="display:flex;flex-direction:column;">
									<p style="margin:0"><a :href="'mailto:' + item.comEmail">{{ item.comEmail }}</a></p>
								</div>
							</div>
						</div>

					</div>
				</td>
			</template>
			<!-- <<< Expanded:Column -->
		</v-data-table>
		<!-- <<< The Data Table -->


		<!-- >>> Dialog: 'Confirm Switch Active/Inactive'  -->
		<v-dialog v-model="showConfirmSwitchActiveInactiveDialog" max-width="800px">
			<v-card class="pa-4">
				<v-card-title>Are you sure you want to switch <strong>{{ resourceNameToSwitchActiveInactive }}</strong> to <strong>{{ switchActiveInactive_StatusToSwitchTo }}</strong>?</v-card-title>
					<v-card-actions class="mt-8">
						<v-spacer></v-spacer>
						<v-btn style="width:120px" depressed outlined color="#ab3b7a" @click="onClick_CloseSwitchActiveInactive"> Cancel</v-btn>
						<v-btn style="width:120px" depressed color="primary" @click="onClick_SwitchActiveInactive"> OK</v-btn>
						<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Dialog: 'Confirm Switch Active/Inactive'  -->


		<!-- >>> Dialog: 'Confirm Delete'  -->
		<v-dialog v-model="showConfirmDeleteDialog" max-width="500px">
			<v-card class="pa-4">
				<v-card-title>Are you sure you want to delete this item?</v-card-title>
					<v-card-actions class="mt-8">
						<v-spacer></v-spacer>
						<v-btn style="width:120px" depressed outlined color="#ab3b7a" @click="onClick_CloseDelete"> Cancel</v-btn>
						<v-btn style="width:120px" depressed color="primary" @click="onClick_DeleteItemConfirm"> OK</v-btn>
						<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <<< Dialog: 'Confirm Delete'  -->


		<!-- >>> Floating 'Add' Button -->
		<v-fab-transition>
			<v-btn fab fixed color="primary" bottom right style="margin-bottom: 50px; margin-right: 50px;" @click="onClick_FloatingButton()">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-fab-transition>
		<!-- <<< Floating 'Add' Button -->


		<!-- >>> Sdr-Component, BottomSheet -->
		<sdr-people-bottom-sheet
			v-model="showSheet"
			:editorMode="editorMode"
			:resourcePrefillObject="resourcePrefillObject">
		</sdr-people-bottom-sheet>
		<!-- <<< Sdr-Component, BottomSheet -->

	</v-container>
</template>
<script>
	import PeopleBottomSheet from './components/core/BottomSheet.vue';

	import { mapActions } from 'vuex';
	import { mapGetters } from 'vuex';


	export default {
		name: 'PeopleHome',

		/* >>> *************************************************************** / /* Components */
		components: {

			'sdr-people-bottom-sheet': PeopleBottomSheet

		}, // eo components{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>> Data Table Header ------------------
				headers : [
					{ text: '', value: 'data-table-select', class: 'sticky-header grey lighten-3' },
					{ text: 'Base', value: 'contractBaseStationCode', class: 'sticky-header grey lighten-3 smaller-column' },
					{ text: 'Name', value: 'fullName', class: 'sticky-header grey lighten-3' },
					{ text: 'Department', value: 'idHrDepartment', class: 'sticky-header grey lighten-3' },
					{ text: 'Position', value: 'contractFunction', class: 'sticky-header grey lighten-3' },
					{ text: 'Add Position', value: 'contractAddFunction', class: 'sticky-header grey lighten-3' },
					{ text: 'Exp. as of', value: 'experiencedFrom', class: 'sticky-header grey lighten-3' },
					{ text: 'Status', value: 'active', class: 'sticky-header grey lighten-3' },
					{ text: 'Actions', value: 'actions', sortable: false, class: 'sticky-header grey lighten-3'},
					{ text: '', value: 'data-table-expand', class: 'sticky-header grey lighten-3' },
				],
				// >>> ------------------------------------
				expanded: [],
				singleExpand: true,
                // >>> ------------------------------------ Tables Checkboxes
                singleSelect: false,
                selected: [],
				// >>> ------------------------------------
				showSheet : false,
				editorMode : null, // 'update, create'
				resourcePrefillObject : null,
				// >>> ------------------------------------
				showConfirmDeleteDialog: false,
				resourceIdToDelete: null,
				// >>> ------------------------------------
				showConfirmSwitchActiveInactiveDialog: false,
				resourceIdToSwitchActiveInactive: null,
				resourceNameToSwitchActiveInactive: '',
				switchActiveInactive_StatusToSwitchTo: ''
			}

		}, // eo funCtion data()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_Resources_Filtered',
				'get_people_searchTerms',
				'get_Shared_UsersGrantsList', //tmp
			]),

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

			/*******************************************************************
			* selected()
			*
			* Desc:
			* Note:
			*
			*/
            selected: function (value) {

				this.actn_set_shared_SelectedMultiResources(value);

            }, // eo function birthdateMenu()


        }, // eof watch{}
        /* <<< ****************************************************************/



		/* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load the 2 Department Calls in parallel.
        * Note: 'Cabin', 'Cockpit'
        *
        */
		created: function() {

            let me = this;


            me.$toc('>>> views/people/Home.vue >>> created');
			this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: false });
			this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: true });
			// this.actn_call_load_AllEmployees({});
			this.actn_call_people_getCrewsOnAirplane();

		}, // eo function created()
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getResourcesOfDepartment',
				'actn_call_load_AllEmployees',
				'actn_call_deleteResource',
				'actn_call_switchActiveStatus',
				'actn_call_people_getCrewsOnAirplane',
				'actn_set_shared_SelectedMultiResources',
			]),



            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
			* onDblClick_DataTableRow()
			*
			* Desc: Event: dbclick:row => Sets Resource Item. Set Mode 'update'.
			* Note: Opens Bottom Sheet too.
			*
			*/
			onDblClick_DataTableRow: function(resourceItem) {

				let me = this;


				me.$toc('>>> views/people/Home.vue >>> onDblClick_DataTableRow');
				this.resourcePrefillObject = resourceItem; // fill up

				this.editorMode = 'update'; // set 'mode' & 'value'
				this.showSheet = true;

			}, // eo function onDblClick_DataTableRow()


			/*******************************************************************
			* onContextMenu_DataTableRow()
			*
			* Desc: Event: contextmenu:row => used for 'Delete Item'.
			* Note:
			*
			*/
			onContextMenu_DataTableRow: function(/* event, item */) {

				let me = this;


				me.$toc('>>> views/people/Home.vue >>> onContextMenu_DataTableRow');
				// event.preventDefault();
				// this.onClick_DeleteResource(item); // simply forward

			}, // eo function onContextMenu_DataTableRow()


			/*******************************************************************
			* onClick_FloatingButton()
			*
			* Desc: Resets Resource Item. Set Mode 'create'.
			* Note: Opens Bottom Sheet too.
			*
			*/
			onClick_FloatingButton: function() {

				let me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_FloatingButton');
				this.resourcePrefillObject = null; // reset

				this.editorMode = 'create'; // set 'mode' & 'value
				this.showSheet = true;

			}, // eo function onClick_FloatingButton()


			/*******************************************************************
			* onClick_ActiveChip()
			*
			* Desc: Switches Active/Inactive.
			* Note: Payload needs status info:
			* Note:   status: 'active' or 'inactive'
			* Note: Change to active: false means sending 'inactive'
			* Note: Change to active: true means sending 'active'
			*
			*/
			onClick_ActiveChip: function(item) {

				let me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_ActiveChip');


				me.showConfirmSwitchActiveInactiveDialog = true;
				me.resourceIdToSwitchActiveInactive = item.id;
				me.resourceNameToSwitchActiveInactive = item.fullName;
				me.switchActiveInactive_StatusToSwitchTo = item.active === true ? 'inactive' : 'active';

			}, // eo function onClick_ActiveChip()



            /******************************************************************* 'Listeners -  Delete'
            * Listeners: Delete Item
            *******************************************************************/
            /*******************************************************************
            * onClick_DeleteResource()
            *
            * Desc: Clicked 'delete' in Action Column.
            * Note: Show Dialog. Remeber 'resourceIdToDelete'.
            *
            */
            // onClick_DeleteResource: function(item) {

			// 	let me = this;


			// 	me.$toc('>>> views/people/Home.vue >>> onClick_DeleteResource');
			// 	this.resourceIdToDelete = item.id; // save
			// 	this.showConfirmDeleteDialog = true;

            // }, // eo function onClick_DeleteResource()


			/*******************************************************************
            * onClick_SwitchActiveInactive()
            *
            * Desc: Clicked 'OK' in 'Switch Active/Inactive Confirm' Dialog.
            * Note:
            *
            */
			onClick_SwitchActiveInactive: function() {

				const me = this;
				let payload = null;


				me.$toc('>>> views/people/Home.vue >>> onClick_SwitchActiveInactive');
				payload = {
					idResource: me.resourceIdToSwitchActiveInactive,
					status: me.switchActiveInactive_StatusToSwitchTo
				};

				this.actn_call_switchActiveStatus(payload);
				this.onClick_CloseSwitchActiveInactive();

			}, // eo fucntion onClick_SwitchActiveInactive()


			/*******************************************************************
            * onClick_CloseSwitchActiveInactive()
            *
            * Desc: Close 'Switch Active/Inactive' Dialog.
            * Note: Close Dialog. Reset 'resourceIdToSwitchActiveInactive'.
            *
            */
			onClick_CloseSwitchActiveInactive: function() {

                let me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_CloseSwitchActiveInactive');
				this.resourceIdToSwitchActiveInactive = null; // reset
				this.showConfirmSwitchActiveInactiveDialog = false;

			}, // eo function onClick_CloseSwitchActiveInactive()


            /*******************************************************************
            * onClick_DeleteItemConfirm()
            *
            * Desc: Clicked 'OK' in 'Delete Confirm' Dialog.
            * Note:
            *
            */
			onClick_DeleteItemConfirm: function() {

				let me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_DeleteItemConfirm');
				this.actn_call_deleteResource(this.resourceIdToDelete);
				this.onClick_CloseDelete();

			}, // eo function onClick_DeleteItemConfirm()


            /*******************************************************************
            * onClick_CloseDelete()
            *
            * Desc: Close 'confirm Delete' Dialog.
            * Note: Close Dialog. Reset 'resourceIdToDelete'.
            *
            */
			onClick_CloseDelete: function() {

                let me = this;


				me.$toc('>>> views/people/Home.vue >>> onClick_CloseDelete');
				this.resourceIdToDelete = null; // reset
				this.showConfirmDeleteDialog = false;

			}, // eo function onClick_CloseDelete()




            /******************************************************************* ''
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * get_ClassForEditedRow()
            *
            * Desc: Returns selected Class if Row was edited (prop: 'wasEdited')
            * Note:
            *
            */
			get_ClassForEditedRow: function(item) {

                let me = this;


				me.$toc('>>> views/people/Home.vue >>> get_ClassForEditedRow');
				return item.wasEdited === true ? 'rowWasEdited' : '';

			}, // eo function get_ClassForEditedRow()

		} // eo methods{}
		/* <<< ****************************************************************/
	};
</script>

<style scoped>
	.v-data-table /deep/ .sticky-header {
		position: sticky;
		top: 65px;
		z-index: 1;
	}

	.v-data-table /deep/ .v-data-table__wrapper {
		margin-top: 0px;
		overflow: unset;
	}

	.v-data-table /deep/ tr:nth-child(2n) {
		background-color: #FAFAFA;
	}

	.v-chip__content {
		font-size: 12px;
	}

	.rowWasEdited {
		/* border-left: 4px solid #AB3B7C;
		padding-left: 4px; */
		/* background-color: #AB3B7C; */
		border: 2px solid #AB3B7C;
		padding: 2px;

	}

</style>

<style>
	.smaller-column {
		width: 5%;
	}

	.v-data-table /deep/ thead tr th {
		background-color: red !important;
	}

	.v-data-table table thead tr th {
		font-size: 15px;
	}
</style>